// 市场服务
export default[

  {
    path: '/market/road',
    name: '活动路演',
    component: () => import(/* webpackChunkName: 'marketService' */ '@/views/marketService/roadList.vue')
  },
  {
    path: '/market/road/roadDetail/:id',
    name: '活动路演详情',
    component: () => import(/* webpackChunkName: 'marketService' */ '@/views/marketService/roadListDetail.vue')
  },
  {
    path: '/market/newsRoadShowList',
    name: '新闻资讯',
    component: () => import(/* webpackChunkName: 'other' */ '@/views/marketService/newsRoadShowList.vue')
  },
  {
    path: '/market/newsRoadShowList/newsRoadShowListDetail/:id',
    name: '新闻资讯详情',
    component: () => import(/* webpackChunkName: 'marketService' */ '@/views/marketService/newsRoadShowListDetail.vue')
  },
  {
    path: '/market/policiesRegulationsList',
    name: '政策法规',
    component: () => import(/* webpackChunkName: 'other' */ '@/views/marketService/policiesRegulationsList.vue')
  },
  {
    path: '/market/policiesRegulationsList/policiesRegulationsListDetail/:id',
    name: '政策法规详情',
    component: () => import(/* webpackChunkName: 'marketService' */ '@/views/marketService/policiesRegulationsListDetail.vue')
  },
  {
    path: '/market/blockDetailAndSearch',
    name: '区块搜索',
    component: () => import(/* webpackChunkName: 'marketService' */ '@/views/homePage/blockchainDeposit/blockDetailAndSearch.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/moudles/marketServiceRouter.js